// DEV-ONLY: the real Chat with fake messages, on the site's real styles.
// Open http://localhost:3000/?chatPreview  (never active in a production build)
import React, { useState } from 'react';
import Chat from '../components/Chat';

const logo = (a) => `https://assets.nhle.com/logos/nhl/svg/${a}_light.svg`;
const MTL = { name: 'Montréal', logo: logo('MTL') };
const BOS = { name: 'Boston', logo: logo('BOS') };
const PLAYERS = [{ id: 'me', username: 'CL34RY' }];
const BETS = [
  { id: 2, bet_type: 'winner', game_description: 'Montréal vs Boston', selection: 'Boston to win', stake: 50, odds: 2.4, potential_win: 120, status: 'pending' },
  { id: 3, bet_type: 'parlay', legs: 3, stake: 25, odds: 8.39, potential_win: 209.75, status: 'pending' },
];
const money = (n) => `$${(+n).toLocaleString('en-CA', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;

export default function ChatPreview() {
  const [, setUnread] = useState(0);
  return (
    <Chat
      open onClose={() => {}} onUnread={setUnread} profile={{ id: 'me', username: 'CL34RY' }} players={PLAYERS} avatarOf={() => null}
      lang="en" myBets={BETS} gameInfo={() => ({ home: MTL, away: BOS })} betText={(b) => b.selection} money={money}
    />
  );
}
